<script>
  const img_step01 = "/assets_default/images/service/loan/guide/repayment-simulation/service_loan_simulation_step_01.webp"
  const img_step02 = "/assets_default/images/service/loan/guide/repayment-simulation/service_loan_simulation_step_02.webp"
  const img_step03 = "/assets_default/images/service/loan/guide/repayment-simulation/service_loan_simulation_step_03.webp"
  const img_step04 = "/assets_default/images/service/loan/guide/repayment-simulation/service_loan_simulation_step_04.webp"
</script>

  <page-header text="返済シミュレーション"></page-header>
  <keyvisual-content
    title="完済予定日を<br>かんたんシミュレーション"
    image="/assets_default/images/service/loan/guide/repayment-simulation/service_loan_simulation_kv.webp"
  >
  </keyvisual-content>
  <section class="owd-section spacing:bottom:64">
    <p class="owd-text:01 spacing:bottom:40">毎月の返済額と返済日を入力するだけで、返済完了日や利息の合計額がアプリですぐに確認できます。無理のない返済計画で、安心して利用できます。</p>
    <ul class="owd-list:annotation">
      <li>ローンの取引は代表口座を利用して行います。</li>
    </ul>
  </section>
  <section class="owd-section spacing:bottom:64">
    <h2 class="owd-heading:03 align:center spacing:bottom:40">利用までの流れ</h2>
    <div class="spacing:bottom:40">
      <div class="owd-section-header spacing:bottom:40">
        <div class="owd-servicesticker owd-servicesticker:yellow owd-servicesticker:en spacing:bottom:16">
          <span class="owd-label:en owd-servicesticker-label">STEP 01</span>
        </div>
        <h2 class="owd-heading:03 spacing:bottom:24">返済シミュレーションをタップ</h2>
        <p class="owd-text:01 spacing:bottom:24">Banking画面内の「ローン」タブを選択後、「Loan」内の「返済シミュレーション」をタップします。</p>
        <div class="owd-img-area">
          <img src={img_step01} width="310" height="174" alt="返済シミュレーションをタップ">
        </div>
      </div>
      <div class="owd-section-header spacing:bottom:40">
        <div class="owd-servicesticker owd-servicesticker:yellow owd-servicesticker:en spacing:bottom:16">
          <span class="owd-label:en owd-servicesticker-label">STEP 02</span>
        </div>
        <h2 class="owd-heading:03 spacing:bottom:24">借入金額を入力</h2>
        <p class="owd-text:01 spacing:bottom:24">シミュレーションする借入金額を入力できます。希望する場合は、追加の借入金額の入力も可能です。</p>
        <div class="owd-img-area">
          <img src={img_step02} width="310" height="174" alt="借入金額を入力">
        </div>
      </div>
      <div class="owd-section-header spacing:bottom:40">
        <div class="owd-servicesticker owd-servicesticker:yellow owd-servicesticker:en spacing:bottom:16">
          <span class="owd-label:en owd-servicesticker-label">STEP 03</span>
        </div>
        <h2 class="owd-heading:03 spacing:bottom:24">返済額・返済日を設定</h2>
        <p class="owd-text:01 spacing:bottom:24">毎月の返済額を入力後、返済日を設定します。</p>
        <div class="owd-img-area">
          <img src={img_step03} width="310" height="174" alt="返済額・返済日を設定">
        </div>
      </div>
      <div class="owd-section-header">
        <div class="owd-servicesticker owd-servicesticker:yellow owd-servicesticker:en spacing:bottom:16">
          <span class="owd-label:en owd-servicesticker-label">STEP 04</span>
        </div>
        <h2 class="owd-heading:03 spacing:bottom:24">シミュレーション結果を確認</h2>
        <p class="owd-text:01 spacing:bottom:24">シミュレーション結果を確認します。そのまま定額返済や追加借入れに設定もできます。</p>
        <div class="owd-img-area">
          <img src={img_step04} width="310" height="174" alt="シミュレーション結果を確認">
        </div>
      </div>
    </div>
    <div class="show:sp">
      <div class="block:center spacing:bottom:16">
        <a href="https://minna-no-ginko.go.link/?tp=pg&pg=bl&adj_t=1t72r13o" class="owd-button owd-button:large owd-button:primary">アプリで確認する</a>
      </div>
      <p class="owd-information align:center"><strong>※アプリをお持ちでない方は、ストアに遷移します。</strong></p>
    </div>
  </section>
